import { render, staticRenderFns } from "./FormNuevoPqr.vue?vue&type=template&id=0481d699&scoped=true"
import script from "./FormNuevoPqr.vue?vue&type=script&lang=js"
export * from "./FormNuevoPqr.vue?vue&type=script&lang=js"
import style0 from "./FormNuevoPqr.vue?vue&type=style&index=0&id=0481d699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481d699",
  null
  
)

export default component.exports